import React from 'react';
import { Link } from 'react-router-dom';

// Official Citytoon brand asset (referenced by URL, unmodified — provided by the site owner).
export const CITYTOON_LOGO_URL = 'https://i0.wp.com/citytoon.org/wp-content/uploads/2022/07/citytoonLogo.png?fit=819%2C861&ssl=1';
export const APP_NAME = 'Citytoon';
export const APP_TAGLINE = 'Le webtoon du réel';

const Logo = ({ size = 'md' }) => {
  const dims = size === 'lg' ? 'w-24 h-24' : size === 'sm' ? 'w-10 h-10' : 'w-12 h-12';
  return (
    <Link to="/" className="flex items-center gap-3 group">
      <img src={CITYTOON_LOGO_URL} alt={`${APP_NAME} logo`} className={`${dims} object-contain shrink-0`} />
      <div className="hidden sm:flex flex-col leading-tight">
        <span className="font-display font-600 text-xl text-foreground">{APP_NAME}</span>
        <span className="text-[11px] text-muted-foreground font-600 tracking-wide">{APP_TAGLINE}</span>
      </div>
    </Link>
  );
};

export default Logo;
